/* SLEEP-9 — interactions + tracking */
(function () {
  'use strict';

  const root = document.querySelector('.s9');
  if (!root) return;

  document.documentElement.classList.add('s9-js');

  const ph = () => (window.posthog && typeof window.posthog.capture === 'function') ? window.posthog : null;

  /* ───────────────────────────────
     1. Reveal on scroll
     ─────────────────────────────── */
  const revealEls = document.querySelectorAll('.s9-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ───────────────────────────────
     2. Section viewed tracking → ELIMINADO
     Era un IntersectionObserver no-op (observaba ~12 secciones y su callback no
     hacía nada — section_viewed lo captura posthog-events.js, fuente única).
     Quitarlo elimina un observer activo entero en móvil. (perf 2026-06-17)
     ─────────────────────────────── */

  /* ───────────────────────────────
     3. CTA click → abrir formulario EasySell
     Todos los CTA de la página abren el form COD de EasySell.
     EasySell se inyecta async: si el usuario hace click antes de que cargue,
     hacíamos scroll a #sleep9-product (un bloque SIN form) y la gente se quedaba
     sin poder comprar. Ahora poll-eamos hasta que el botón exista y lo disparamos.
     ─────────────────────────────── */
  /* #es-sticky es el trigger CONFIABLE: abre el modal aun estando display:none en
     desktop. #es-form-button (botón inline) NO responde a un click sintético.
     Por eso el orden importa — #es-sticky primero, el resto como respaldo. */
  const findEasySellTrigger = () => {
    return document.querySelector('#es-sticky')
      || document.querySelector('#es-form-button')
      || document.querySelector('.es-cta-btn')
      || document.querySelector('.es-sticky-btn')
      || document.querySelector('.es-button')
      || document.querySelector('[data-easysell-trigger]');
  };

  const openEasySell = () => {
    const trigger = findEasySellTrigger();
    if (trigger) { trigger.click(); return true; }
    return false;
  };

  let esPolling = false;
  document.querySelectorAll('[data-s9-cta]').forEach((cta) => {
    cta.addEventListener('click', (e) => {
      e.preventDefault();
      /* cta_clicked lo captura posthog-events.js (fuente única) */

      if (openEasySell()) return; // app ya cargada → abre al instante

      /* EasySell aún no inyectó el botón → poll ~2.4s hasta que cargue.
         200ms (no 100) = mitad de ticks en el main-thread; guard para no apilar
         timers si el user toca varios CTAs. */
      if (esPolling) return;
      esPolling = true;
      let tries = 0;
      const timer = setInterval(() => {
        if (openEasySell()) { clearInterval(timer); esPolling = false; return; }
        if (++tries > 12) {
          clearInterval(timer); esPolling = false;
          /* último recurso: llevar al bloque de producto donde está el form */
          const target = document.querySelector('#sleep9-product');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    });
  });

  /* ───────────────────────────────
     4. Sticky mobile CTA
     ─────────────────────────────── */
  const sticky = document.querySelector('.s9-sticky-cta');
  const hero = document.querySelector('.s9-hero');
  if (hero) {
    const showAfter = hero.offsetHeight * 0.7;
    let visible = false;
    let esSticky = null; // cache de #es-sticky (lo inyecta EasySell async)
    const applyState = () => {
      const shouldShow = window.scrollY > showAfter && window.innerWidth <= 1024;
      if (shouldShow === visible) return; // solo tocar el DOM cuando CAMBIA el estado
      visible = shouldShow;
      if (sticky) sticky.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('s9-sticky-active', shouldShow);
      document.body.classList.toggle('s9-es-on', shouldShow);
      /* Sacar el sticky de EasySell (#es-sticky) apenas se pasa el hero, sin
         esperar a la sección de producto (muy abajo). Solo móvil; en desktop
         lo maneja EasySell. Cacheado para no querySelectorear en cada frame. */
      if (!esSticky || !document.contains(esSticky)) esSticky = document.querySelector('#es-sticky');
      if (esSticky && window.innerWidth <= 1024) {
        esSticky.style.setProperty('display', shouldShow ? 'flex' : 'none', 'important');
      }
      /* sticky_cta_shown — antes lo observaba un MutationObserver sobre body en
         posthog-events.js; ahora se dispara aquí, en el momento exacto. */
      if (shouldShow && !window.__s9StickyShown) {
        window.__s9StickyShown = true;
        const p = ph();
        if (p) p.capture('sticky_cta_shown', {
          time_to_show_ms: Math.round(performance.now()),
          page_path: location.pathname,
          page_template: (document.querySelector('#MainContent')?.dataset?.template) || '',
        });
      }
    };
    /* rAF guard: colapsa los eventos scroll/resize a ≤1 lectura de layout por
       frame (antes leía innerWidth + escribía clases/style en cada evento). */
    let ticking = false;
    const onScrollResize = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; applyState(); });
    };
    window.addEventListener('scroll', onScrollResize, { passive: true });
    window.addEventListener('resize', onScrollResize, { passive: true });
    applyState();
  }

  /* ───────────────────────────────
     5. FAQ accordion — auto-close others when opening one
     ─────────────────────────────── */
  const faqItems = document.querySelectorAll('.s9-faq__item');
  faqItems.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        faqItems.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
        /* faq_opened lo captura posthog-events.js si se necesita */
      }
    });
  });

  /* ───────────────────────────────
     6. Counter animation on ingredient cards (subtle)
     ─────────────────────────────── */
  const ingCards = document.querySelectorAll('.s9-ingredients__card');
  if (ingCards.length && 'IntersectionObserver' in window) {
    const ioIng = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            entry.target.style.transition = `opacity .5s ease ${i * 80}ms, transform .5s ease ${i * 80}ms`;
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            ioIng.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    ingCards.forEach((c) => {
      c.style.opacity = '0';
      c.style.transform = 'translateY(16px)';
      ioIng.observe(c);
    });
  }
})();

/* Scroll cue: lunita "Desliza" en el hero — invita a bajar, se desvanece al hacer scroll o a los 7s */
(function () {
  'use strict';
  if (!document.querySelector('.s9')) return;
  var hero = document.querySelector('.s9-hero');
  if (!hero || hero.querySelector('.s9-scrollcue')) return;
  var cue = document.createElement('div');
  cue.className = 's9-scrollcue';
  cue.setAttribute('aria-hidden', 'true');
  cue.innerHTML =
    '<svg class="s9-scrollcue__moon" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="var(--s9-gold,#C9A961)"/></svg>' +
    '<span class="s9-scrollcue__label">Desliza</span>' +
    '<svg class="s9-scrollcue__chevron" viewBox="0 0 18 10" aria-hidden="true"><path d="M2 2l7 6 7-6"/></svg>';
  hero.appendChild(cue);
  var hidden = false;
  function hide() {
    if (hidden) return;
    hidden = true;
    cue.classList.add('is-hidden');
    window.removeEventListener('scroll', onScroll);
    setTimeout(function () { if (cue.parentNode) cue.parentNode.removeChild(cue); }, 700);
  }
  function onScroll() { if (window.scrollY > 40) hide(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(hide, 7000);
})();
